import apiService from 'apiService'
import React from 'react'
import Swal from 'sweetalert2'

export default function DeleteUserIcon({ userId, refreshTable }) {
    const handleClick = async () => {
        Swal.fire({
            icon: 'question',
            title: 'Διαγραφή χρήστη?',
            text: `Σίγουρα θέλετε να διαγράψετε το χρήστη ${userId}?`,
            showCancelButton: true,
            confirmButtonText: 'ΔΙΑΓΡΑΦΗ',
            confirmButtonColor: 'red',
            cancelButtonText: 'ΑΚΥΡΟ'
        }).then(async result => {
            if (!result.isConfirmed) return
            const response = await apiService.delete(`/users/${userId}`)
            if (response === null) return
            refreshTable(+Date.now())
            Swal.fire({
                icon: 'success',
                title: 'Επιτυχία!',
                text: `Επιτυχής διαγραφή χρήστη!`,
                showCancelButton: false,
                confirmButtonText: 'ΟΚ',
                confirmButtonColor: '#51a351',
                cancelButtonText: 'ΑΚΥΡΟ'
            })
        })
    }

    return <i title="Διαγραφή Χρήστη" className="fas fa-trash text-red-500 mr-2" style={{ cursor: 'pointer' }} onClick={handleClick}></i>
}
